module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/MyConsulationRequest/MyConsulationRequest.component.html
// module id = ./src/app/Pages/tasks/MyConsulationRequest/MyConsulationRequest.component.html
// module chunks = main